import type { BusinessType } from "@zenith/features/AuthZ/permissions";
import { useRegistrationType } from "@zenith/hooks/useRegistrationType";
import { WalletBalanceInfoResponseDTO } from "@zenith/services/user";

// Same split used throughout the app for facial-eligibility (BOAS-8200/
// 8203/8197/7938): individual and sole-proprietorship businesses get the
// "Individual & Sole Proprietorship" permission table from BOAS-7641,
// everything else gets "Multi-signatory".
const IND_REGISTRATION_TYPES = new Set([
  WalletBalanceInfoResponseDTO.registrationType.INDIVIDUAL,
  WalletBalanceInfoResponseDTO.registrationType.SOLE_PROPRIETORSHIP,
]);

/** Which of BOAS-7641's two permission tables applies to the signed-in business. */
export const useBusinessType = (): BusinessType => {
  const { registrationType } = useRegistrationType();
  return IND_REGISTRATION_TYPES.has(
    registrationType as WalletBalanceInfoResponseDTO.registrationType
  )
    ? "IND"
    : "MS";
};
